import { createAsyncThunk } from '@reduxjs/toolkit';
import get_plans from 'functions/server/get_plans.js';

export const fetchPlans = createAsyncThunk('plans/fetchPlans', async () => {
  /*
  Fetches the public plan catalog (each plan's limits + `features` entitlement
  map) from the backend. Takes no arguments; returns the array of plans (may be
  empty). Rejects if the endpoint is unavailable — feature gating fails open on a
  non-succeeded catalog, so a rejection just leaves everything unlocked.
  */
  const response = await get_plans();
  return Array.isArray(response) ? response : [];
});
